import React from 'react';
import styled from 'styled-components';
import { ReportOptionWrapper } from '../ReportOption/ReportOption.styles';

export const SVG = styled.svg`
    overflow: visible;
    .a,
    .c {
        fill: none;
    }
    .a,
    .b,
    .c {
        stroke: ${({ theme }) => theme.green[700]};
        stroke-width: 1.5px;
    }
    .b,
    .d {
        fill: ${({ theme }) => theme.white.ff};
    }
    .c {
        stroke-linecap: round;
    }
    .e,
    .f {
        stroke: none;
    }
    .f {
        fill: ${({ theme }) => theme.green[700]};
    }

    .star {
        transition: all 0.25s ease-in-out;
        transform-origin: 23.5px 22.5px;
    }
    .left-cylinder,
    .middle-cylinder,
    .right-cylinder {
        transition: all 0.25s ease-in-out;
    }
    ${ReportOptionWrapper}:hover & {
        .star {
            transform: translateY(-30px) rotate(290deg);
            stroke-width: 2.5px;
        }
        .left-cylinder {
            transform: translateX(-10px) scale(1.05) rotate(-5deg);
        }
        .middle-cylinder {
            transform: translateY(-10px) scale(1.05);
        }
        .right-cylinder {
            transform: translateY(-15px) translateX(15px) scale(1.05) rotate(35deg);
        }
        .circle {
            fill: ${({ theme }) => theme.green[100]};
        }
    }
`;

const CompetitiveMediaSVG = () => (
    <SVG width={140.998} height={140.998} viewBox="0 0 140.998 140.998">
        <g transform="translate(0.75 0.75)">
            <path
                className="circle a"
                d="M70.469,147.778a69.749,69.749,0,1,1,69.749-69.749,69.749,69.749,0,0,1-69.749,69.749Z"
                transform="translate(-0.72 -8.28)"
            />
            <g transform="translate(19.499 59.589)">
                <g className="left-cylinder">
                    <path
                        className="b"
                        d="M0-11.468V10.941c0,5.086,8.73,9.208,19.5,9.208S39,16.026,39,10.941V-11.468"
                        transform="translate(0.051 20.906)"
                    />
                    <ellipse className="b" cx={19.5} cy={9.5} rx={19.5} ry={9.5} />
                    <path
                        className="a"
                        d="M38,9.5c0,5.247-8.507,9.5-19,9.5S0,14.747,0,9.5"
                        transform="translate(0 11)"
                    />
                    <path
                        className="c"
                        d="M-11179.163-13834.824a19.665,19.665,0,0,0,6.462,2.755"
                        transform="translate(11183 13853.823)"
                    />
                    <path
                        className="c"
                        d="M-11179.163-13834.824a19.665,19.665,0,0,0,6.462,2.755"
                        transform="translate(11183 13864.954)"
                    />
                </g>
            </g>
            <g transform="translate(48.338 52.589)">
                <g className="middle-cylinder">
                    <path
                        className="b"
                        d="M0-24.811V13.712C0,18.8,8.73,22.92,19.5,22.92S39,18.8,39,13.712V-24.811"
                        transform="translate(0 34.344)"
                    />
                    <ellipse className="b" cx={19.5} cy={9.5} rx={19.5} ry={9.5} />
                    <path
                        className="a"
                        d="M39,9.5c0,5.1-8.73,9.232-19.5,9.232S0,14.6,0,9.5"
                        transform="translate(0 25.768)"
                    />
                    <path
                        className="a"
                        d="M39,9.5c0,5.1-8.73,9.232-19.5,9.232S0,14.6,0,9.5"
                        transform="translate(0 13.439)"
                    />
                    <path
                        className="c"
                        d="M-11179.163-13834.824a19.665,19.665,0,0,0,6.462,2.755"
                        transform="translate(11182.161 13853.446)"
                    />
                    <path
                        className="c"
                        d="M-11179.163-13834.824a19.665,19.665,0,0,0,6.462,2.755"
                        transform="translate(11182.161 13866.618)"
                    />
                    <path
                        className="c"
                        d="M-11179.163-13834.824a19.665,19.665,0,0,0,6.462,2.755"
                        transform="translate(11182.161 13878.618)"
                    />
                </g>
            </g>
            <g transform="translate(77.999 90.138)">
                <g className="right-cylinder">
                    <path
                        className="b"
                        d="M0-.351V9.138c0,5.086,8.507,9.208,19,9.208s19-4.123,19-9.208V-.44"
                        transform="translate(0 9.426)"
                    />
                    <ellipse className="b" cx={19} cy={9} rx={19} ry={9} />
                    <path
                        className="c"
                        d="M-11179.163-13834.824a19.665,19.665,0,0,0,6.462,2.755"
                        transform="translate(11182.5 13852.825)"
                    />
                </g>
            </g>
            <g transform="translate(45.338 22.149)">
                <g className="star d">
                    <path
                        className="e"
                        d="M 32.52671813964844 39.90104293823242 C 32.1744499206543 39.90108108520508 31.82930946350098 39.81589126586914 31.50089073181152 39.64785003662109 L 24.20815086364746 35.9163703918457 C 23.68185997009277 35.64707946777344 23.09119033813477 35.50474166870117 22.5 35.50474166870117 C 21.90880966186523 35.50474166870117 21.31814002990723 35.64707946777344 20.79184913635254 35.9163703918457 L 13.49911022186279 39.64785003662109 C 13.17074966430664 39.81586074829102 12.82559013366699 39.90104293823242 12.47321033477783 39.90104293823242 C 11.82645988464355 39.90104293823242 11.18344020843506 39.60053253173828 10.75312995910645 39.0971794128418 C 10.32549953460693 38.59696197509766 10.14737987518311 37.95691299438477 10.25160026550293 37.294921875 L 11.53639030456543 29.13363075256348 C 11.72163009643555 27.95688056945801 11.3306303024292 26.75015068054199 10.49046039581299 25.9056510925293 L 4.6663498878479 20.0515308380127 C 4.058629989624023 19.44068145751953 3.855180025100708 18.58687210083008 4.122109889984131 17.76760101318359 C 4.389050006866455 16.94833183288574 5.056429862976074 16.37826156616211 5.907350063323975 16.24267196655273 L 14.01957988739014 14.94999122619629 C 15.20221042633057 14.76154136657715 16.23176002502441 14.01145172119141 16.77362060546875 12.94350147247314 L 20.49349975585938 5.612091064453125 C 20.8848991394043 4.840701103210449 21.63499069213867 4.380161285400391 22.5 4.380161285400391 C 23.36500930786133 4.380161285400391 24.1151008605957 4.840701103210449 24.50650024414062 5.612091064453125 L 28.22637939453125 12.94350147247314 C 28.76823043823242 14.01144123077393 29.79777908325195 14.76153087615967 30.98040962219238 14.94998168945312 L 39.0926513671875 16.24267196655273 C 39.94356918334961 16.37826156616211 40.6109504699707 16.94833183288574 40.87789154052734 17.76760101318359 C 41.14482879638672 18.58687210083008 40.94137954711914 19.44068145751953 40.33366012573242 20.05152130126953 L 34.50954055786133 25.90564155578613 C 33.66936111450195 26.75016212463379 33.27835845947266 27.95688056945801 33.46363067626953 29.13364219665527 L 34.7484016418457 37.294921875 C 34.85258865356445 37.95676040649414 34.67449188232422 38.59673309326172 34.24691009521484 39.09694290161133 C 33.81655883789062 39.60037994384766 33.17350006103516 39.90098190307617 32.52671813964844 39.90104293823242 Z"
                    />
                    <path
                        className="f"
                        d="M 22.5 5.130161285400391 C 21.92332077026367 5.130161285400391 21.42325973510742 5.437179565429688 21.16233062744141 5.951450347900391 L 17.44245910644531 13.28285217285156 C 16.7922306060791 14.56438064575195 15.55677032470703 15.46449089050293 14.13760948181152 15.69064140319824 L 6.025371551513672 16.98332214355469 C 5.458091735839844 17.07372093200684 5.013168334960938 17.45376205444336 4.835208892822266 17.99994087219238 C 4.657249450683594 18.5461311340332 4.792888641357422 19.11534118652344 5.198028564453125 19.5225715637207 L 11.02215957641602 25.37668037414551 C 12.03036880493164 26.39010047912598 12.49956130981445 27.83817100524902 12.27724838256836 29.2502613067627 L 10.99246978759766 37.41155242919922 C 10.9033203125 37.97789001464844 11.12311935424805 38.37577056884766 11.32320022583008 38.60982131958008 C 11.61291885375977 38.94871139526367 12.04283142089844 39.15103912353516 12.47320938110352 39.15103912353516 C 12.70568084716797 39.15103912353516 12.93589019775391 39.09355163574219 13.15748023986816 38.98017120361328 L 20.45019912719727 35.24870300292969 C 21.08173942565918 34.92555236816406 21.79055023193359 34.75474166870117 22.5 34.75474166870117 C 23.20943069458008 34.75474166870117 23.91823959350586 34.92555236816406 24.54977989196777 35.24869155883789 L 31.84251022338867 38.98015975952148 C 32.06410980224609 39.09355163574219 32.29434204101562 39.15103912353516 32.52679061889648 39.15103912353516 C 32.95709991455078 39.15103912353516 33.38697814941406 38.94869232177734 33.67673873901367 38.6097526550293 C 33.87683868408203 38.37568283081055 34.09667205810547 37.97780227661133 34.00753021240234 37.41155242919922 L 32.72274017333984 29.2502613067627 C 32.50043869018555 27.83816146850586 32.96963882446289 26.39009094238281 33.97785186767578 25.37668037414551 L 39.80195999145508 19.52256202697754 C 40.20711135864258 19.11533164978027 40.34273910522461 18.5461311340332 40.16479110717773 17.99994087219238 C 39.98683166503906 17.45376205444336 39.54190826416016 17.07372093200684 38.9746208190918 16.98332214355469 L 30.86238861083984 15.69064140319824 C 29.44322967529297 15.46449089050293 28.2077693939209 14.56438064575195 27.55755043029785 13.28286170959473 L 23.83766937255859 5.951450347900391 C 23.57673072814941 5.437179565429688 23.07666969299316 5.130161285400391 22.5 5.130161285400391 M 22.5 3.630165100097656 C 23.55985832214355 3.630165100097656 24.61971473693848 4.177684783935547 25.17532920837402 5.272731781005859 L 28.89521026611328 12.60414123535156 C 29.3300895690918 13.46124076843262 30.14929962158203 14.05808067321777 31.09844017028809 14.20933151245117 L 39.21067047119141 15.50201034545898 C 41.62657165527344 15.88698196411133 42.59074020385742 18.84621047973633 40.86534118652344 20.58049201965332 L 35.04122924804688 26.43461036682129 C 34.36655044555664 27.11277198791504 34.05572891235352 28.07203102111816 34.20449066162109 29.01700210571289 L 35.48928070068359 37.17829132080078 C 35.87062835693359 39.60071182250977 33.34233856201172 41.43254089355469 31.15925979614258 40.31552124023438 L 23.86651992797852 36.58404159545898 C 23.0084114074707 36.14497375488281 21.9915885925293 36.14497375488281 21.13348007202148 36.58404159545898 L 13.84074020385742 40.31552124023438 C 11.65765380859375 41.43254089355469 9.129367828369141 39.60071182250977 9.510719299316406 37.17829132080078 L 10.79550170898438 29.01700210571289 C 10.94427108764648 28.07203102111816 10.63344955444336 27.11277198791504 9.958770751953125 26.43461036682129 L 4.134651184082031 20.58050155639648 C 2.409259796142578 18.84621047973633 3.373428344726562 15.88698196411133 5.789329528808594 15.50201034545898 L 13.90155982971191 14.20933151245117 C 14.85070037841797 14.05808067321777 15.6699104309082 13.46124076843262 16.10478973388672 12.60414123535156 L 19.82467079162598 5.272731781005859 C 20.38028526306152 4.177684783935547 21.44014167785645 3.630165100097656 22.5 3.630165100097656 Z"
                    />
                </g>
            </g>
        </g>
    </SVG>
);

export default CompetitiveMediaSVG;
